var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 18,
    height: 18,
    transform: "translate(0 -0.363)",
    fill: "#30b524"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963",
    transform: "translate(0 0.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47567",
    "data-name": "Path 47567",
    d: "M2.645,14.11H6.383a.881.881,0,0,0,.626-.256l6.1-6.109,2.5-2.451a.881.881,0,0,0,.005-1.247l-.005-.005L11.875.261A.881.881,0,0,0,10.628.256l-.005.005L8.137,2.756,2.019,8.865a.881.881,0,0,0-.256.626v3.738a.882.882,0,0,0,.882.882m8.6-11.981,2.495,2.495L12.492,5.877,10,3.382ZM3.526,9.852,8.754,4.625,11.249,7.12,6.021,12.347H3.526ZM16.75,15.874H.882a.882.882,0,0,0,0,1.763H16.75a.882.882,0,0,0,0-1.763",
    transform: "translate(0 0)",
    fill: "#30b524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.10d7efc8d8101602579f199e8e8d4255.svg";
export { ForwardRef as ReactComponent };